import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import styles from './App.module.css'
import { Slices } from './components/builder/Slices';
import { Header } from './components/header/Header';
import { Player } from './components/player/Player';
import { Files } from './components/builder/Files';

import { initializeApp } from "firebase/app";
import { Credits } from './components/builder/Credits';
import { Search } from './components/player/Search';
import { BuilderContainer } from './components/builder/BuilderContainer';
import { Start } from './components/builder/Start';
import { Playlist } from './components/player/Playlist';
import { Auth } from './components/auth/Auth';
import { PlayerContainer } from './components/player/PlayerContainer';
import { didTryAlAC } from './store/actions/authActions';
import { authenticate } from './store/reducers/authReducer';
import { Finish } from './components/builder/Finish';
import { Art } from './components/builder/Art';
import { Upload } from './components/builder/Upload';

const firebaseConfig = {
  apiKey: "AIzaSyCk2IOoXfT-VRrmA2-lSRcPZyV0fK7TD8Q",
  authDomain: "spardja-86810.firebaseapp.com",
  projectId: "spardja-86810",
  storageBucket: "spardja-86810.appspot.com",
  messagingSenderId: "467135852813",
  appId: "1:467135852813:web:422b04fb5543f7ada7c044"
};

initializeApp(firebaseConfig);

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    (async () => {
      const userData = await localStorage.getItem('userData')
      if (!userData) {
        dispatch(didTryAlAC())
        return
      }
      const transformedData = JSON.parse(userData)
      const { token, userId, email, expirationDate } = transformedData

      const expiryDate = new Date(expirationDate)
      if (expiryDate <= new Date() || !token || !userId || !email) {
        dispatch(didTryAlAC())
        return
      }
      const expiresIn = expiryDate.getTime() - new Date().getTime()
      dispatch(authenticate(token, userId, email, expiresIn))
    })()
  }, [dispatch])

  return (
    <div className={styles.app_wrapper}>
      <Header />
      <div className={styles.app}>
        <Routes>
          <Route path='/' element={<Navigate to='player' />} />
          <Route path='player' element={<PlayerContainer />}>
            <Route index element={<Search />} />
            <Route path=':artist' element={<Playlist />} />
            <Route path=':artist/:songTitle' element={<Player />} />
          </Route>
          <Route path='builder' element={<BuilderContainer />}>
            <Route index element={<Start />} />
            <Route path='credits' element={<Credits />} />
            <Route path='art' element={<Art />} />
            <Route path='slices' element={<Slices />} />
            <Route path='files' element={<Files />} />
            <Route path='upload' element={<Upload />} />
            <Route path='finish' element={<Finish />} />
          </Route>
          <Route path='auth' element={<Auth />} />
          <Route path='*' element={<Navigate to='player' />} />
        </Routes>
      </div>
    </div>
  )
}

export default App;
